<a href="#" class="skip-link" (click)="skipToMainContent($event)">Skip to main content</a>
<ng-container>
  <app-header *ngIf="headerVisible()" aria-label="Navigation header"></app-header>
</ng-container>
<app-emulation-displayer></app-emulation-displayer>
<main class="main-content" id="main-content">
  <router-outlet />
</main>
<ng-container><app-footer aria-label="Footer"></app-footer></ng-container>
